// Brand logo — official PNG asset. Never recreate typographically.
export default function Logo({ size = "sm", className = "" }) {
  const isLg = size === "lg";
  return (
    <img
      src="/logo.png"
      alt="The Safe Mama Editorial"
      className={`logo-img ${isLg ? "logo-img-lg" : "logo-img-sm"} ${className}`}
      draggable="false"
    />
  );
}
